import { getSlateSpacingPixels } from "@faire/retailer-shared/SlateMappings/getSlateSpacingPixels";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { DIMENSION_BY_SIZE } from "@faire/web/slate/Avatar/Avatar";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import React from "react";

import { SDUIOnClickHandler } from "@faire/retailer/components/SDUI/__internal__/SDUIOnClickHandler";
import {
  getSlateWebAvatarSize,
  SDUIAvatarElementRenderer,
} from "@faire/retailer/components/SDUI/ComponentRenderers/Avatar/SDUIAvatarElementRenderer";
import { SDUITileInstanceRendererProps } from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/__internal__/types";
import { SDUITypographyRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";

import * as styles from "./styles/SDUIAvatarTileRenderer.css";

export const SDUIAvatarTileRenderer = ({
  tileElement,
  loggingData,
}: SDUITileInstanceRendererProps) => {
  const { on_click } = tileElement;
  const { avatar_element, avatar_list, subtitle } =
    tileElement.avatar_tile ?? {};

  const avatarList =
    isNotUndefined(avatar_list) && avatar_list.length > 0
      ? avatar_list
      : [avatar_element].filter(isNotUndefined);

  if (avatarList.length === 0) {
    return null;
  }

  return (
    <SDUIOnClickHandler
      onClickActions={on_click}
      loggingData={loggingData}
      logLegacyClickEvent
      className={styles.avatarTileContainer}
    >
      <Row align="center">
        {avatarList.map((avatarElement, index) => {
          const overlapAmount =
            DIMENSION_BY_SIZE[
              getSlateWebAvatarSize(avatarElement.avatar?.style?.size)
            ] - getSlateSpacingPixels("R");
          return (
            <SDUIAvatarElementRenderer
              key={`${index}-${avatarElement.logging_data?.instance_identifier}`}
              className={styles.stackedAvatarElement}
              componentStyle={assignInlineVars({
                [styles.avatarOverlapAmount]: `-${overlapAmount}px`,
              })}
              avatarElement={avatarElement}
              loggingData={loggingData}
            />
          );
        })}
      </Row>
      {subtitle ? (
        <>
          <Spacer height="3x" />
          <SDUITypographyRenderer
            textElement={subtitle}
            loggingData={loggingData}
          />
        </>
      ) : null}
    </SDUIOnClickHandler>
  );
};
